/**
 * @flow
 * @relayHash 44cd27ecf568d8034f9c8ed7e06d0107
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SearchableContractorGroupDropdownQueryVariables = {|
  contractorGroupName?: ?string
|};
export type SearchableContractorGroupDropdownQueryResponse = {|
  +contractorGroupsByUser: ?{|
    +edgeCount: ?number,
    +totalCount: ?number,
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: string,
      |}
    |}>,
  |}
|};
export type SearchableContractorGroupDropdownQuery = {|
  variables: SearchableContractorGroupDropdownQueryVariables,
  response: SearchableContractorGroupDropdownQueryResponse,
|};
*/


/*
query SearchableContractorGroupDropdownQuery(
  $contractorGroupName: String
) {
  contractorGroupsByUser(name: $contractorGroupName, orderBy: "name", first: 10) {
    edgeCount
    totalCount
    edges {
      node {
        id
        name
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "contractorGroupName",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "contractorGroupsByUser",
    "storageKey": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 10
      },
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "contractorGroupName"
      },
      {
        "kind": "Literal",
        "name": "orderBy",
        "value": "name"
      }
    ],
    "concreteType": "ContractorGroupNodeConnection",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "edgeCount",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "totalCount",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "ContractorGroupNodeEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "ContractorGroupNode",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SearchableContractorGroupDropdownQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "SearchableContractorGroupDropdownQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "SearchableContractorGroupDropdownQuery",
    "id": null,
    "text": "query SearchableContractorGroupDropdownQuery(\n  $contractorGroupName: String\n) {\n  contractorGroupsByUser(name: $contractorGroupName, orderBy: \"name\", first: 10) {\n    edgeCount\n    totalCount\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '23600a70e5c1393dee2b2f7629dcd0b4';
module.exports = node;
